export default {
  Initial: 'Initial',
  Paused: 'Paused',
  Running: 'Running',
  Succeed: 'Succeed',
  GameOver: 'GameOver',
}
